export const EMPTY_HELPER_TEXT_STRING = '\u200b';
